import ArrayPanel from "./ArrayPanel";

export default ArrayPanel;
